import { render, staticRenderFns } from "./NotaFiscalForm.vue?vue&type=template&id=552e4765&scoped=true"
import script from "./NotaFiscalForm.vue?vue&type=script&lang=js"
export * from "./NotaFiscalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e4765",
  null
  
)

export default component.exports